import styled, { css } from 'styled-components';
import { rem, rgba } from 'polished';
import variables from '@styles/variables';
import { onlineGridElementHeight, offlineGridElementHeight } from '@styles/mixins/gridElementHeight';
import Text from '@atoms/Text/Text';

export const StyledVoucherCard = styled.div<{ $productType: OnlineOfflineProductType }>`
  ${onlineGridElementHeight()};
  overflow: hidden;
  color: ${variables.colors.black};
  grid-column: span 1;
  z-index: 1;
  border-radius: ${rem(8)};

  ${(props) =>
    props.$productType === 'offline' &&
    css`
      ${offlineGridElementHeight()};
    `}
`;

export const StyledVoucherCardContent = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: ${rem(16)};
  height: 100%;
  background-image: url('/images/voucher_background.png');
  background-position: center;
  background-size: cover;
`;

export const StyledHeadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledVoucherText = styled(Text)`
  margin: 0 ${rem(12)};
`;

export const StyledVoucherOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2;
  display: flex;
  padding: ${rem(40)};
  align-items: center;
  justify-content: center;
  background-color: ${rgba(variables.colors.white, 0.75)};
  height: 100%;
`;
